import styled from 'styled-components'

export const LoadingPageWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 1);
  z-index: ${({ theme }) => theme.zIndexes.screenLoader};

  h2,
  p {
    text-align: center;
  }
`
